import { FACEBOOK_CLICK_ID_URL_PARAM } from '../constants';

export const getFacebookClickIdFromURL = (): string => {
  const regex = new RegExp(`[?&]${FACEBOOK_CLICK_ID_URL_PARAM}=([^&#]*)`);
  const results = regex.exec(window.location.search);

  return results ? decodeURIComponent(results[1]) : '';
};
